import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import gql from 'graphql-tag';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { DataCafService } from 'src/app/services/data-caf.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotaCreditoCabeceraComponent } from './nota-credito-cabecera/nota-credito-cabecera.component';
import { NotaCreditoDetallesComponent } from './nota-credito-detalles/nota-credito-detalles.component';

@Component({
  selector: 'app-nota-credito',
  templateUrl: './nota-credito.component.html',
  styleUrls: ['./nota-credito.component.scss'],
  providers: [SecurityService],
})
export class NotaCreditoComponent implements OnInit {
  // Modales
  @ViewChild(NotaCreditoCabeceraComponent, { static: true }) cabeceraComponent: NotaCreditoCabeceraComponent;
  @ViewChild(NotaCreditoDetallesComponent, { static: true }) detallesComponent: NotaCreditoDetallesComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  // optionsBodega: Array<any> = [];
  // optionsCondPago: Array<any> = [];
  // optionsListaPrecio: Array<any> = [];
  // optionsMedida: Array<any> = [];
  // optionsCategoria: Array<any> = [];
  // optionsFamilia: Array<any> = [];
  // optionsTipoTraslado: Array<any> = [];
  // optionsTipoEnvio: Array<any> = [];
  // dataCabecera: any = null
  // dataFooter: any = null

  processing: boolean = false;
  validaFormatoSecundario: boolean = true;

  // Variables para prevenir duplicidad
  private isSaving: boolean = false;
  private lastSaveTimestamp: number = 0;
  private readonly MIN_SAVE_INTERVAL: number = 3000; // 3 segundos mínimo entre guardados
  /** Cooldown tras éxito/error: el botón Guardar permanece deshabilitado unos segundos */
  private cooldown: boolean = false;
  private readonly GUARDAR_COOLDOWN_MS: number = 1500;

  /** Deshabilita el botón Guardar mientras se guarda o está en cooldown (processing se maneja por separado para el spinner) */
  get guardarDisabled(): boolean {
    return this.isSaving || this.cooldown;
  }

  // TransactionId para idempotencia - se mantiene durante toda la sesión de creación de la NC
  // Se inicializa como string vacío para mantener consistencia en todo el flujo
  private currentTransactionId: string = '';
  codigos_dte: number[];

  // COUNT PARA LAS FACTURAS REALIZADAS
  contadorFacturas: number = 0;

  // Utils
  private log: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private dataCafService: DataCafService
  ) {
    this.log = this.clog.log('NOTA-CREDITO');

    // Seteamos los codigos DTE
    this.codigos_dte = [61];
    // Seteamos el valor del codigo DTE
    this.dataCafService.setDataCodigoDTE(61);
  }

  ngOnInit() {
    // Generar transactionId inicial al cargar el componente
    this.generateTransactionId();
  }


  // Genera un nuevo transactionId único para la sesión actual de creación de NC
  // Formato: NC_timestamp_randomstring
  private generateTransactionId(): void {
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substring(2, 11);
    this.currentTransactionId = `NC_${timestamp}_${randomString}`;
    this.log('TransactionId generado:', this.currentTransactionId);
  }

  public handleCabeceraChange(dataCabecera) {
    // this.dataCabecera = dataCabecera
    // this.detallesComponent.handleCabeceraChange(this.dataCabecera)
    this.detallesComponent.handleCabeceraChange(dataCabecera);
  }

  beginSave() {
    // Validar si ya se está procesando una operación o en cooldown
    if (this.processing || this.isSaving) {
      this.toastrService.warning('Ya se está procesando una operación. Espere a que termine.');
      return;
    }
    if (this.cooldown) {
      this.toastrService.warning('Espere unos segundos antes de guardar de nuevo.');
      return;
    }

    // Validar intervalo mínimo entre guardados
    const currentTime = Date.now();
    if (currentTime - this.lastSaveTimestamp < this.MIN_SAVE_INTERVAL) {
      this.toastrService.warning('Debe esperar al menos 3 segundos entre operaciones.');
      return;
    }

    this.GuardarNotaCredito();
  }

  //Guardar Nota de Crédito
  GuardarNotaCredito() {
    // Marcar como guardando para prevenir duplicidad
    this.isSaving = true;
    this.lastSaveTimestamp = Date.now();

    // Agregar transactionId para idempotencia - mismo ID durante toda la sesión de creación
    if (!this.currentTransactionId) {
      this.generateTransactionId();
    }

    const isHeaderValid = this.cabeceraComponent.validate();
    if (!isHeaderValid) {
      this.toastrService.warning('Complete la información requerida');
      this.isSaving = false;
      return;
    }

    const headerData = this.cabeceraComponent.getHeaderData();
    const { dataCabecera, tipoNotaCredito, tipoCorreccionMonto, rebajaStock, tipoAplicacion, fechaDocumento } = headerData;
    this.log('headerData', headerData);
    if (!dataCabecera) {
      this.toastrService.warning('Complete la información requerida');
      this.isSaving = false;
      return;
    }

    // Validar si ya existe una nota de crédito para este documento
    this.validarExistenciaNotaCredito(dataCabecera, (existe) => {
      if (existe) {
        this.toastrService.error('Ya existe una nota de crédito para este documento.');
        this.isSaving = false;
        return;
      }

      // Continuar con el proceso de guardado
      this.continuarGuardado(headerData);
    });
  }

  private validarExistenciaNotaCredito(dataCabecera: any, callback: (existe: boolean) => void) {
    const { cabecera } = dataCabecera;
    const folio = cabecera.folio;
    const fecha_emision = cabecera.fecha_emision;

    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmisor: Decimal, $tipoDteCodigo: Decimal, $folio: Decimal, $fechaEmision: Date) {
            documento {
              existeNotaCredito(rutEmisor: $rutEmisor, tipoDteCodigo: $tipoDteCodigo, folio: $folio, fechaEmision: $fechaEmision) {
                respuesta
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
              }
            }
          }
        `,
        variables: {
          rutEmisor: cabecera.rut_emisor,
          tipoDteCodigo: cabecera.tipo_dte_codigo,
          folio: folio,
          fechaEmision: fecha_emision
        },
        fetchPolicy: 'no-cache'
      },
      (response) => {
        const { respuesta, mensajes } = response.data.documento.existeNotaCredito;
        if (mensajes && mensajes.some(m => m.tipo === 'ERROR')) {
          this.messageRendererService.showErrors(mensajes);
          callback(false);
          return;
        }
        callback(respuesta);
      }
    );
  }

  private continuarGuardado(headerData: any) {
    const { dataCabecera, tipoNotaCredito, tipoCorreccionMonto, rebajaStock, tipoAplicacion, fechaDocumento } = headerData;

    // Validar integridad de los datos antes de continuar
    if (!this.validarIntegridadDatos(dataCabecera)) {
      this.isSaving = false;
      return;
    }

    const { cabecera: cabeceraOrigen, descuentosGlobales } = dataCabecera;

    const detailsData = this.detallesComponent.getDetailsData();
    const { observaciones, glosa_administrativa, motivoGeneral, detalleDocumento: detalleDocumentoOrigen } = detailsData;

    const sendDctosGlobales = (tipoNotaCredito === 2 && tipoCorreccionMonto === 10) || tipoNotaCredito === 3;
    this.log('sendDctosGlobales', sendDctosGlobales);

    const folio = cabeceraOrigen.folio;
    const fecha_emision = cabeceraOrigen.fecha_emision;

    // Clone objects
    let cabecera = _.cloneDeep(cabeceraOrigen);
    let detalleDocumento = _.cloneDeep(detalleDocumentoOrigen);

    const esCorreccionDeMonto = cabecera.additionalInfo.esCorreccionDeMonto;

    // Clear detalle
    detalleDocumento.map((detalle) => {
      if (detalle.atributos)
        detalle.atributos.map((attr) => {
          delete attr.__typename;
        });

      if (detalle.listaProductoFormato)
        detalle.listaProductoFormato.forEach((form) => {
          delete form.__typename;
        });

      delete detalle.selectedFormato;
    });

    // Clear cabecera
    delete cabecera.additionalInfo;
    delete cabecera.cliente_nombre;
    delete cabecera.direccion_nombre;
    delete cabecera.folio;
    delete cabecera.tipo_devolucion_codigo;
    delete cabecera.tipo_envio_codigo;
    delete cabecera.tipo_traslado_codigo;
    delete cabecera.vendedor_nombre;

    // Set data
    cabecera.observaciones = observaciones;
    cabecera.tipo_ncnd_codigo = tipoNotaCredito;

    const inputParams: any = {
      entidadReferencia: {
        rut_emisor: cabecera.rut_emisor,
        tipo_dte_codigo: cabecera.tipo_dte_codigo,
        folio,
        fecha_emision,
        transactionId: this.currentTransactionId, // ID único para prevenir duplicidad
      },
      entidad: {
        cabecera,
        descuentosGlobales: [],
        detalleDocumento,
      },
    };

    // Set defaults
    inputParams.entidad.cabecera.fecha_emision = fechaDocumento;
    inputParams.entidad.cabecera.glosa_administrativa = '';
    inputParams.entidad.cabecera.motivo_devolucion_codigo = 0;
    inputParams.entidad.cabecera.aplica_rebaja = false;
    inputParams.entidad.cabecera.es_correcion_monto = false;

    // ADMINISTRATIVA
    if (tipoNotaCredito === 1) {
      inputParams.entidad.detalleDocumento = [];
      inputParams.entidad.cabecera.glosa_administrativa = glosa_administrativa;
      inputParams.entidad.cabecera.motivo_devolucion_codigo = motivoGeneral;
      if (!this.validateAndHandleGlosaAdministativa(glosa_administrativa)) {
        this.isSaving = false;
        return;
      }

      if (!this.validateAndHandleMotivoGeneral(motivoGeneral)) {
        this.isSaving = false;
        return false;
      }
    }
    // POR CORRECCIÓN DE MONTO
    else if (tipoNotaCredito === 2) {
      this.log('tipoCorreccionMonto', tipoCorreccionMonto);

      inputParams.entidad.cabecera.aplica_nota_credito = tipoAplicacion === 1;
      inputParams.entidad.cabecera.es_correcion_monto = esCorreccionDeMonto;

      // DEVOLUCION
      if (tipoCorreccionMonto === 10) {
        if (!this.validateAndHandleDetalles(detalleDocumento)) {
          this.isSaving = false;
          return false;
        }
        inputParams.entidad.cabecera.aplica_rebaja = rebajaStock;
        inputParams.entidad.descuentosGlobales = descuentosGlobales;
        inputParams.entidad.cabecera.motivo_devolucion_codigo = motivoGeneral;
        if (!this.validateAndHandleMotivoGeneral(motivoGeneral)) {
          this.isSaving = false;
          return false;
        }
      }
      // CORRECCION MONTO
      if (tipoCorreccionMonto === 20) {
        if (!this.validateAndHandleDetalles(detalleDocumento, false)) {
          this.isSaving = false;
          return false;
        }
        inputParams.entidad.cabecera.motivo_devolucion_codigo = motivoGeneral;
        if (!this.validateAndHandleMotivoGeneral(motivoGeneral)) {
          this.isSaving = false;
          return false;
        }
      }
    }
    // POR ANULACION
    else if (tipoNotaCredito === 3) {
      if (!this.validateAndHandleDetalles(detalleDocumento, false, false)) {
        this.isSaving = false;
        return false;
      }

      inputParams.entidad.cabecera.aplica_nota_credito = tipoAplicacion === 1;
      inputParams.entidad.cabecera.motivo_devolucion_codigo = motivoGeneral;
      if (!this.validateAndHandleMotivoGeneral(motivoGeneral)) {
        this.isSaving = false;
        return false;
      }
      inputParams.entidad.cabecera.aplica_rebaja = rebajaStock;
      inputParams.entidad.descuentosGlobales = descuentosGlobales;
    }

    // Validar motivo general en base a si está mostrado en pantalla
    if (dataCabecera.cabecera.additionalInfo.showMotivoGeneral) {
      if (!this.validateAndHandleMotivoGeneral(motivoGeneral)) {
        this.isSaving = false;
        return false;
      }
    }

    // Lo elimino acá. Clear detalle->additionalInfo
    detalleDocumento.map((detalle) => {
      delete detalle.additionalInfo;
    });

    this.log('inputParams', JSON.stringify(inputParams));
    this.log('inputParams', inputParams);

    this.processing = true;

    if (dataCabecera.cabecera.tipo_dte_codigo == 46) {
      this.mutationGuardarNotaCreditoFT(inputParams, ({ mensajes, respuesta }) => {
        const hayErrores = mensajes && mensajes.length > 0 && mensajes.some((m) => m.tipo === 'ERROR');
        if (hayErrores) {
          this.messageRendererService.showErrors(mensajes);
          this.resetGuardarConCooldown();
          return;
        }
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          this.resetGuardarConCooldown();
          return;
        }

        const { folio } = respuesta.cabecera;
        this.toastrService.success(`Nota crédito guardada con folio ${folio}`);
        this.resetGuardarConCooldown();
        this.CleanData();
        this.contadorFacturas++;
      });
    } else {
      this.mutationGuardarNotaCredito(inputParams, ({ mensajes, respuesta }) => {
        const hayErrores = mensajes && mensajes.length > 0 && mensajes.some((m) => m.tipo === 'ERROR');
        if (hayErrores) {
          this.messageRendererService.showErrors(mensajes);
          this.resetGuardarConCooldown();
          return;
        }
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          this.resetGuardarConCooldown();
          return;
        }

        const { folio } = respuesta.cabecera;

        if (mensajes.length > 0 && mensajes[0].tipo === TipoMensaje.WARNING) {
          this.toastrService.warning(`${mensajes[0].texto} - Nota crédito guardada con folio ${folio}`);
        } else {
          this.toastrService.success(`Nota crédito guardada con folio ${folio}`);
        }

        this.resetGuardarConCooldown();
        this.CleanData();
        this.contadorFacturas++;
      });
    }
  }

  /**
   * Resetea flags de guardado y aplica cooldown: el botón Guardar
   * permanece deshabilitado GUARDAR_COOLDOWN_MS ms para evitar doble envío.
   */
  private resetGuardarConCooldown(): void {
    this.processing = false;
    this.isSaving = false;
    this.cooldown = true;
    setTimeout(() => {
      this.cooldown = false;
    }, this.GUARDAR_COOLDOWN_MS);
  }

  private CleanData() {
    this.cabeceraComponent.cleanData();
    this.detallesComponent.cleanData();
    // Generar nuevo transactionId cuando se limpia la data (nueva NC)
    this.generateTransactionId();
    // Reset flags de duplicidad y cooldown
    this.isSaving = false;
    this.processing = false;
    this.cooldown = false;
  }

  /**
   * Valida la integridad de los datos antes del envío para prevenir duplicidad
   */
  private validarIntegridadDatos(dataCabecera: any): boolean {
    if (!dataCabecera || !dataCabecera.cabecera) {
      this.toastrService.error('Datos de cabecera inválidos');
      return false;
    }

    const { cabecera } = dataCabecera;

    // Validar que los campos requeridos estén presentes
    if (!cabecera.folio || !cabecera.fecha_emision || !cabecera.rut_emisor || !cabecera.tipo_dte_codigo) {
      this.toastrService.error('Faltan datos requeridos en la cabecera');
      return false;
    }

    // Validar que el folio sea un número válido
    if (isNaN(Number(cabecera.folio)) || Number(cabecera.folio) <= 0) {
      this.toastrService.error('El folio del documento no es válido');
      return false;
    }

    return true;
  }

  /**
   * Genera un ID único para la transacción para prevenir duplicidad
   */
  private generarIdTransaccion(): string {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substr(2, 9);
    return `NC_${timestamp}_${random}`;
  }

  private validateAndHandleGlosaAdministativa(glosa) {
    if (!glosa || glosa.length === 0) {
      this.toastrService.warning('Ingrese glosa');
      return false;
    }
    return true;
  }

  private validateAndHandleDetalles(detalles, validateMotivo: boolean = true, validaCantidades: boolean = true) {

    if (!detalles || detalles.length === 0) {
      this.toastrService.warning('Ingrese detalle');
      return false;
    }

    if (validateMotivo) {
      // for (let i = 0; i < detalles.length; i++) {
      //   if (!detalles[i].motivo_devolucion_especifico_codigo || detalles[i].motivo_devolucion_especifico_codigo === 0) {
      //     this.toastrService.warning('Ingrese motivo devolución específico')
      //     return false
      //   }
      // }
      const notValids = detalles.filter((detalle) => !detalle.motivo_devolucion_especifico_codigo || detalle.motivo_devolucion_especifico_codigo === 0);
      if (notValids.length === detalles.length) {
        this.toastrService.warning('Ingrese al menos un motivo de devolución específico');
        return false;
      }
    }

    // cantidades
    //Cantidades no es necesario validarlas en una NC de anulación
    if (validaCantidades) {
      for (let i = 0; i < detalles.length; i++) {
        if (Number(detalles[i].cantidad) > Number(detalles[i].additionalInfo.cantidad)) {
          this.toastrService.warning('Existe una cantidad no válida');
          return false;
        }

        if (detalles[i].listaProductoFormato != null) {
          detalles[i].listaProductoFormato.find((formato) => {
            if (formato.formato_secundario === detalles[i].formato_codigo) {
              if (detalles[i].formato_codigo === "UNID") {
                //Valido si estoy devolviendo algo en un formato distinto al original
                if (detalles[i].formato_codigo != detalles[i].formato_original) {
                  let cantFormatoAnterior = detalles[i].listaProductoFormato.find(x => x.formato_codigo === detalles[i].formato_original).cantidad;
                  if (detalles[i].cantidad > cantFormatoAnterior - 1) {
                    this.toastrService.error("La devolución de unidades no puede ser superior a la cantidad de unidades de la caja.");
                    this.validaFormatoSecundario = false;
                  }
                }
                else {
                  //Si es el mismo formato, solo validar que no supere la cantidad original
                  if (detalles[i].cantidad > detalles[i].cantidad_original) {
                    this.toastrService.error("La devolución de unidades no puede ser superior a la cantidad original.");
                    this.validaFormatoSecundario = false;
                  }
                }


              }
              else {
                if (detalles[i].cantidad > 1) {
                  this.toastrService.error('La devolucion de Media Caja no puede ser superior a 1');
                  this.validaFormatoSecundario = false;
                } else {
                  this.validaFormatoSecundario = true;
                }
              }

            }
          });
        }
      }
    }


    if (this.validaFormatoSecundario == false) {
      return false;
    } else {
      this.validaFormatoSecundario = true
      return true
    }


    // detalles.map(detalle => {
    //   if (!detalle.motivo_devolucion_especifico_codigo || detalle.motivo_devolucion_especifico_codigo === 0) {
    //     this.toastrService.warning('Ingrese motivo devolución específico')
    //     return false
    //   }
    // });
  }

  private validateAndHandleMotivoGeneral(motivoGeneral) {
    this.log('validateAndHandleMotivoGeneral', motivoGeneral);
    if (!motivoGeneral || motivoGeneral === 0 || motivoGeneral === '0') {
      this.toastrService.warning('Ingrese motivo devolución general');
      return false;
    }
    return true;
  }

  private mutationGuardarNotaCredito(inputParams, callback) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: documentoDTOInputType, $entidadReferencia: documentoInputType) {
            documento {
              guardarNotaCredito(entidad: $entidad, entidadReferencia: $entidadReferencia) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.guardarNotaCredito;
        callback({ mensajes, respuesta });
      }
    );
  }

  private mutationGuardarNotaCreditoFT(inputParams, callback) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: documentoDTOInputType, $entidadReferencia: documentoInputType) {
            documento {
              guardarNotaCreditoFT(entidad: $entidad, entidadReferencia: $entidadReferencia) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.guardarNotaCreditoFT;
        callback({ mensajes, respuesta });
      }
    );
  }

  clearFromButton() {
    this.modalConfirm.show(() => {
      this.CleanData();
    });
  }

  onDetalleDocumentoChange(registros) {
    this.cabeceraComponent.updateDetalleDocumento(registros);
  }
}
